import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";

import { MedAvatarComponent } from "./med-avatar.component";

@NgModule({
  declarations: [
    MedAvatarComponent,
  ],
  imports: [
    CommonModule,
    MedIconsModule,
  ],
  exports: [
    MedAvatarComponent,
  ],
})
export class MedAvatarModule { }
